
import { computed, reactive } from "vue"

import payload from "./payload"

export default reactive ( {

  county: computed( () => payload.value?.county_name ),

  state: computed( () => payload.value?.state_name ),

  stateAbbr: computed( () => payload.value?.state_abbr ),

  ready: computed( () => payload.value?.ready ),
  
  exists: computed( () => payload.value?.exists )

} )